import React from 'react';
import PropTypes from 'prop-types';
import FileDownload from 'components/file-download';
import {
  FileDownloadListComponent,
  FileDownloadLists,
  FilesComponent,
  Header,
} from './FileDownloadList.styles.js';
import  { ReactHtmlParser } from 'helpers/utilities.js';

const FileDownloadList = ({ downloads, labels }) => {
  return (
    <FileDownloadListComponent>
      <FileDownloadLists>
        {downloads?.map((list, listIndex) => {
          const { files, header } = list;
          return (
            <FilesComponent key={`files-${listIndex}`}>
              {header && <Header>{ReactHtmlParser(header)}</Header>}
              {files?.map((file, index) => {
                return <FileDownload key={`${file.file}-${index}`} {...file} labels={labels} />;
              })}
            </FilesComponent>
          );
        })}
      </FileDownloadLists>
    </FileDownloadListComponent>
  );
};

FileDownloadList.propTypes = {
  downloads: PropTypes.array,
  labels: PropTypes.object,
};

export default FileDownloadList;
